<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop d-flex justify-content-md-center">
        <div class="col-md-6">
          <v-app style="margin: 0; background-color: transparent;">
            <v-form ref="form" v-model="valid">
              <v-card-text class="card">
                <v-row v-if="management === 'Management'">
                  <v-toolbar color="#01579B" class="top-hero6" dark flat>
                    <v-toolbar-title
                      >You are contacting 360 Real Estate for Property
                      Management</v-toolbar-title
                    >
                  </v-toolbar>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.name"
                      :rules="firstRules"
                      :counter="15"
                      label="First name"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.address"
                      :rules="addressRules"
                      :counter="50"
                      label="Address"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.phone"
                      :rules="phoneRules"
                      :counter="12"
                      label="Phone"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>
                    <span class="text-danger" v-if="errors.email">
                      {{ errors.email[0] }}
                    </span>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="form.password"
                      :rules="[v => !!v || 'password is required']"
                      type="password"
                      label="Password"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      type="password"
                      v-model="form.password_confirmation"
                      :rules="[
                        form.password === form.password_confirmation ||
                          'Password must match'
                      ]"
                      label="Password Confirmation"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-else-if="buyer === 'Buyer'">
                  <v-toolbar color="#01579B" class="top-hero6" dark flat>
                    <v-toolbar-title
                      >You are looking to Buy a Home!</v-toolbar-title
                    >
                  </v-toolbar>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.name"
                      :rules="firstRules"
                      :counter="15"
                      label="First name"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.address"
                      :rules="addressRules"
                      :counter="50"
                      label="Address"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.phone"
                      :rules="phoneRules"
                      :counter="12"
                      label="Phone"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>
                    <span class="text-danger" v-if="errors.email">
                      {{ errors.email[0] }}
                    </span>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="form.password"
                      :rules="[v => !!v || 'password is required']"
                      type="password"
                      label="Password"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      type="password"
                      v-model="form.password_confirmation"
                      :rules="[
                        form.password === form.password_confirmation ||
                          'Password must match'
                      ]"
                      label="Password Confirmation"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-else-if="seller === 'Seller'">
                  <v-toolbar color="#01579B" class="top-hero6" dark flat>
                    <v-toolbar-title
                      >You are looking to Sell a Home!</v-toolbar-title
                    >
                  </v-toolbar>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.name"
                      :rules="firstRules"
                      :counter="15"
                      label="First name"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.address"
                      :rules="addressRules"
                      :counter="50"
                      label="Address"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.phone"
                      :rules="phoneRules"
                      :counter="12"
                      label="Phone"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>
                    <span class="text-danger" v-if="errors.email">
                      {{ errors.email[0] }}
                    </span>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="form.password"
                      :rules="[v => !!v || 'password is required']"
                      type="password"
                      label="Password"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      type="password"
                      v-model="form.password_confirmation"
                      :rules="[
                        form.password === form.password_confirmation ||
                          'Password must match'
                      ]"
                      label="Password Confirmation"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-else>
                  <v-col>
                    Want to:
                    <v-radio-group
                      :rules="[v => !!v || 'You must select to continue!']"
                      required
                      v-model="form.selected"
                      row
                    >
                      <v-radio label="Buy" value="Buyer"></v-radio>
                      <v-radio label="Sell" value="Seller"></v-radio>
                      <v-radio label="Management" value="Management"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.name"
                      :rules="firstRules"
                      :counter="15"
                      label="First name"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.address"
                      :rules="addressRules"
                      :counter="50"
                      label="Address"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.phone"
                      :rules="phoneRules"
                      :counter="12"
                      label="Phone"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="form.email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>
                    <span class="text-danger" v-if="errors.email">
                      {{ errors.email[0] }}
                    </span>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="form.password"
                      :rules="[v => !!v || 'password is required']"
                      type="password"
                      label="Password"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      type="password"
                      v-model="form.password_confirmation"
                      :rules="[
                        form.password === form.password_confirmation ||
                          'Password must match'
                      ]"
                      label="Password Confirmation"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-btn
                :disabled="!valid"
                color="#03A9F4"
                class="mr-4"
                dark
                @click="register"
              >
                Register
              </v-btn>
            </v-form>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["seller"],
  data() {
    return {
      valid: true,
      valid2: true,

      management: this.$route.params.state,
      buyer: this.$route.params.state,

      errors: [],

      form: {
        name: "",
        address: "",
        phone: "",
        email: "",
        password: "",
        password_confirmation: "",
        selected: this.$route.params.state || ""
      },

      firstRules: [
        v => !!v || "Fist name is required",
        v =>
          (v && v.length <= 15) || "Fist name must be less than 15 characters"
      ],

      lastRules: [
        v => !!v || "Last name is required",
        v =>
          (v && v.length <= 15) || "Last name must be less than 15 characters"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],

      numberRules: [
        v => !!v || "Phone number is required",
        v =>
          (v && v.length <= 50) ||
          "Phone number must be less than 15 characters"
      ],

      addressRules: [
        v => !!v || "Address is required",
        v => v.length >= 8 || "Address must be grater than 8 characters"
      ],

      phoneRules: [
        v => !!v || "Phone is required",
        v => v.length <= 12 || "Phone must be less than 12 characters"
      ]
    };
  },

  mounted() {
    if (this.$route.params.state == "Management") {
      fetch("https://api.ipify.org?format=json")
        .then(x => x.json())

        .then(({ ip }) => {
          setTimeout(() => {
            window.axios
              .post("api/geoRent", { rawIp: ip, tagId: 3 })
              .then(res => {
                console.log(res.data);
                this.$route.params.state = "";
              });
          }, 10000);
        });
    }
  },

  methods: {
    register() {
      this.valid = false;
      this.$store
        .dispatch("register", this.form)
        .then(() => {
          this.form = {};
          Swal.fire({
            icon: "success",
            title: "User successfully created",
            text:
              "Thanks for registering an account in HomesBy360! Before we get started, we'll need to verify your email",
            footer: "Check your email"
          });
          this.$router.push({ name: "VerifyMessage" });
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    }
  }
};
</script>
